import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    Label,
    Input,
} from "reactstrap";
import { addVisionType, getvision } from "../../service/api";
import DatatableTables from "./Vision_type_list";
import { Link } from "react-router-dom";

document.title = "Vision Type | optom";

const THEME = "#C62828";

const defaultPrices = { uc: "", hc: "", hmc_blue: "", shmc_blue: "", photo: "" };

const Vision_type = () => {
    const [visionList, setVisionList] = useState([]);
    const [selectedVision, setSelectedVision] = useState("");
    const [stock, setStock] = useState({ ...defaultPrices });
    const [surface, setSurface] = useState({ ...defaultPrices });
    const [refreshTable, setRefreshTable] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        fetchVisions();
    }, []);

    const fetchVisions = async () => {
        try {
            const res = await getvision();
            setVisionList(res?.data || []);
        } catch (err) {
            console.log("Error fetching visions:", err);
        }
    };

    const handleStockChange = (e) => {
        setStock({ ...stock, [e.target.name]: e.target.value });
    };

    const handleSurfaceChange = (e) => {
        setSurface({ ...surface, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!selectedVision) {
            toast.error("Please select a vision (lens) type.", { position: "top-center" });
            return;
        }
        setSaving(true);
        try {
            await addVisionType({ vision: selectedVision, sub_type: "Stock", ...stock });
            await addVisionType({ vision: selectedVision, sub_type: "Surface", ...surface });
            toast.success("Vision type prices saved successfully.", {
                position: "top-center",
                autoClose: 2000,
            });
            setStock({ ...defaultPrices });
            setSurface({ ...defaultPrices });
            setSelectedVision("");
            setRefreshTable(prev => !prev);
        } catch (err) {
            toast.error("Error saving vision type.", { position: "top-center" });
            console.log("Save error:", err);
        } finally {
            setSaving(false);
        }
    };

    const selectedVisionName = visionList.find(v => v._id === selectedVision)?.vision || "";

    const priceInput = (value, name, onChange) => (
        <Input
            type="number"
            min="0"
            step="0.01"
            name={name}
            value={value}
            onChange={onChange}
            placeholder="0.00"
            style={{ minWidth: 80, textAlign: "right" }}
        />
    );

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Page Header */}
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        {/* <CardTitle className="mb-4">ADD Patient</CardTitle> */}
                        <h4 className="page-title">Vision Type and lens Category</h4>
                        <Link to="/Vision_type_list" className="btn btn-danger">List</Link>
                    </div>

                    <Row>
                        <Col md={12}>
                            <Card style={{ borderRadius: 10, border: `1px solid #f5c6c6` }}>
                                <CardBody>
                                    {/* Vision selector */}
                                    <Row className="mb-4 align-items-end">
                                        <Col md={4}>
                                            <Label style={{ fontWeight: 600, color: "#333" }}>
                                                Vision (Lens Category) <span style={{ color: THEME }}>*</span>
                                            </Label>
                                            <select
                                                className="form-control"
                                                value={selectedVision}
                                                onChange={e => setSelectedVision(e.target.value)}
                                                style={{ borderColor: selectedVision ? THEME : "#ced4da" }}
                                            >
                                                <option value="">— Select Vision Type —</option>
                                                {visionList.map(v => (
                                                    <option key={v._id} value={v._id}>{v.vision}</option>
                                                ))}
                                            </select>
                                        </Col>
                                        <Col md={8}>
                                            <div style={{
                                                background: "#fff8f8",
                                                border: `1px dashed ${THEME}`,
                                                borderRadius: 8,
                                                padding: "10px 16px",
                                                fontSize: 13,
                                                color: "#555"
                                            }}>
                                                <strong style={{ color: THEME }}>!</strong> Select a vision category above, then enter the
                                                retail prices (R) for each coating type under <em>Stock</em> and <em>Surface</em> sub-types. Click Save to store both rows.
                                            </div>
                                        </Col>
                                    </Row>

                                    {/* Pricing Table */}
                                    <div style={{ overflowX: "auto" }}>
                                        <table className="table table-bordered" style={{ minWidth: 700 }}>
                                            <thead>
                                                <tr style={{ background: "#f8f8f8" }}>
                                                    <th style={{ color: "#000", fontWeight: 700, width: 180 }}>Lenses</th>
                                                    <th style={{ color: "#000", fontWeight: 700, width: 110 }}>Sub-Type</th>
                                                    <th style={{ color: "#000", fontWeight: 700, textAlign: "center" }}>
                                                        UC<br /><small style={{ fontWeight: 400, color: "#666" }}>Uncoated</small>
                                                    </th>
                                                    <th style={{ color: "#000", fontWeight: 700, textAlign: "center" }}>
                                                        HC<br /><small style={{ fontWeight: 400, color: "#666" }}>Hard Coat</small>
                                                    </th>
                                                    <th style={{ color: "#000", fontWeight: 700, textAlign: "center" }}>
                                                        HMC Blue<br /><small style={{ fontWeight: 400, color: "#666" }}>Multi-Coat Blue</small>
                                                    </th>
                                                    <th style={{ color: "#000", fontWeight: 700, textAlign: "center" }}>
                                                        SHMC Blue<br /><small style={{ fontWeight: 400, color: "#666" }}>Super HMC Blue</small>
                                                    </th>
                                                    <th style={{ color: "#000", fontWeight: 700, textAlign: "center" }}>
                                                        Photo<br /><small style={{ fontWeight: 400, color: "#666" }}>Photochromic</small>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {/* Stock Row */}
                                                <tr>
                                                    <td
                                                        rowSpan={2}
                                                        style={{
                                                            verticalAlign: "middle",
                                                            fontWeight: 700,
                                                            fontSize: 15,
                                                            color: selectedVisionName ? THEME : "#aaa",
                                                            background: "#fafafa",
                                                        }}
                                                    >
                                                        {selectedVisionName || <span style={{ fontStyle: "italic", fontSize: 13 }}>Select vision above</span>}
                                                    </td>
                                                    <td style={{ verticalAlign: "middle" }}>
                                                        <span style={{
                                                            background: "#e8f5e9",
                                                            color: "#2e7d32",
                                                            padding: "3px 10px",
                                                            borderRadius: 12,
                                                            fontWeight: 600,
                                                            fontSize: 13,
                                                        }}>Stock</span>
                                                    </td>
                                                    <td>{priceInput(stock.uc, "uc", handleStockChange)}</td>
                                                    <td>{priceInput(stock.hc, "hc", handleStockChange)}</td>
                                                    <td>{priceInput(stock.hmc_blue, "hmc_blue", handleStockChange)}</td>
                                                    <td>{priceInput(stock.shmc_blue, "shmc_blue", handleStockChange)}</td>
                                                    <td>{priceInput(stock.photo, "photo", handleStockChange)}</td>
                                                </tr>
                                                {/* Surface Row */}
                                                <tr>
                                                    <td style={{ verticalAlign: "middle" }}>
                                                        <span style={{
                                                            background: "#e3f2fd",
                                                            color: "#1565c0",
                                                            padding: "3px 10px",
                                                            borderRadius: 12,
                                                            fontWeight: 600,
                                                            fontSize: 13,
                                                        }}>Surface</span>
                                                    </td>
                                                    <td>{priceInput(surface.uc, "uc", handleSurfaceChange)}</td>
                                                    <td>{priceInput(surface.hc, "hc", handleSurfaceChange)}</td>
                                                    <td>{priceInput(surface.hmc_blue, "hmc_blue", handleSurfaceChange)}</td>
                                                    <td>{priceInput(surface.shmc_blue, "shmc_blue", handleSurfaceChange)}</td>
                                                    <td>{priceInput(surface.photo, "photo", handleSurfaceChange)}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Coating guide */}
                                    <div style={{
                                        display: "flex",
                                        gap: 12,
                                        flexWrap: "wrap",
                                        marginTop: 8,
                                        marginBottom: 20,
                                    }}>
                                        {[
                                            { label: "UC", desc: "Uncoated – basic lens, no coating" },
                                            { label: "HC", desc: "Hard Coat – scratch resistant" },
                                            { label: "HMC Blue", desc: "Multi-layer coat + blue light filter" },
                                            { label: "SHMC Blue", desc: "Super multi-layer + blue light + UV" },
                                            { label: "Photo", desc: "Photochromic – darkens in sunlight" },
                                        ].map(c => (
                                            <div key={c.label} style={{
                                                background: "#f9f9f9",
                                                border: "1px solid #e0e0e0",
                                                borderRadius: 6,
                                                padding: "4px 10px",
                                                fontSize: 12,
                                                color: "#555",
                                            }}>
                                                <strong style={{ color: "#333" }}>{c.label}</strong>: {c.desc}
                                            </div>
                                        ))}
                                    </div>

                                    {/* Save button */}
                                    <div>
                                        <button
                                            className="btn"
                                            onClick={handleSubmit}
                                            disabled={saving}
                                            style={{
                                                background: THEME,
                                                color: "#fff",
                                                fontWeight: 600,
                                                padding: "9px 30px",
                                                borderRadius: 6,
                                            }}
                                        >
                                            {saving ? "Saving..." : "Save Prices"}
                                        </button>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    {/* List */}
                    <DatatableTables refresh={refreshTable} />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Vision_type;
